module.exports = __webpack_public_path__ + "static/img/93.19dba56.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/25/93.jpg
// module id = 751
// module chunks = 0